<template lang="pug">
  v-container
    v-layout(row wrap)
      v-flex.text-xs-center(xs12)
        div You have successfully logged, in you can continue shopping 
      v-layout(row v-if="count>0")
        v-flex(xs12)
          v-divider.shortInline
          span.center or
          v-divider.shortInline
      v-flex.text-xs-center(xs12 v-if="count>0")
        v-btn(to="/checkout" color="orange") Checkout
      
    //- div the user: {{user}}
</template>
<script>
export default {
  data: () =>({
    
  }),
  computed:{
    user() {return this.$store.state.user},
    count(){
      let amt = 0 
      if (this.$store.state.cart){
        let cart = this.$store.state.cart
        amt = cart.items.length + cart.packages.length
      }
      return amt
    }
  }
}
</script>
<style scoped>
.shortInline{
  min-width: 40%;
  display: inline-block;
}
.center{
  width: 20%;
  display: inline-block;
  text-align: center;
}
</style>


